export default __webpack_public_path__ + "static/media/8.3.4d6ac919.webm";